export const getUserInitials = (fullname = "") => {
  return fullname.split(" ").reduce((initial, str) => {
    return initial + str.charAt(0).toUpperCase();
  }, "");
};

export const formatRequestPayload = (data) => {
  return { data };
};
